import React, { Component } from 'react'
import MenuFooter from "~/data/menu/menu_footer.json"

class FooterBottom extends Component {
  render() {
    let menuItems;
    menuItems = MenuFooter.bottom.menu_items.map((data, index) => {
      return <li key={index} className={data.menu_class_name}><a href={data.menu_url}>{data.menu_title}</a></li>
    })

    return (
      <div className="row">
        <div className="col-md-5 cols">
          <p className="copyright">{MenuFooter.bottom.text}</p>
        </div>
        <div className="col-md-7 cols">
          <ul>{menuItems}</ul>
        </div>
      </div>
      
    )
  }
}

export default FooterBottom
